import { MileageRate, RateFormErrors } from "../types";

export const emptyRate = (year: number): Partial<MileageRate> => ({
  year,
  vehicle_type: "CAR",
  energy_type: "THERMAL",
  power_cv_min: 0,
  power_cv_max: 3,
  distance_min: 0,
  distance_max: 99999,
  fixed_amount: 0,
  per_km_amount: 0,
  is_active: true,
});

export function validateRate(rate: Partial<MileageRate>, mt: any): RateFormErrors {
  const errors: RateFormErrors = {};
  const err = mt?.errors ?? {};

  if (rate.year === undefined || !Number.isInteger(rate.year) || rate.year < 1900) {
    errors.year = err.yearInvalid ?? "Invalid year";
  }
  if (!rate.vehicle_type) {
    errors.vehicle_type = err.vehicleTypeRequired ?? "Vehicle type is required";
  }
  if (rate.power_cv_min === undefined || rate.power_cv_min < 0) {
    errors.power_cv_min = err.mustBePositive ?? "Must be ≥ 0";
  }
  if (rate.power_cv_max === undefined || rate.power_cv_max < 0) {
    errors.power_cv_max = err.mustBePositive ?? "Must be ≥ 0";
  }
  if (rate.power_cv_min !== undefined && !Number.isInteger(rate.power_cv_min)) {
    errors.power_cv_min = err.mustBeInteger ?? "Must be an integer";
  }
  if (rate.power_cv_max !== undefined && !Number.isInteger(rate.power_cv_max)) {
    errors.power_cv_max = err.mustBeInteger ?? "Must be an integer";
  }
  if (
    rate.power_cv_min !== undefined &&
    rate.power_cv_max !== undefined &&
    rate.power_cv_min > rate.power_cv_max
  ) {
    errors.power_cv_max = err.maxMustBeGreaterThanMin ?? "Max must be ≥ min";
  }
  if (rate.distance_min === undefined || rate.distance_min < 0) {
    errors.distance_min = err.mustBePositive ?? "Must be ≥ 0";
  }
  if (rate.distance_max === undefined || rate.distance_max < 0) {
    errors.distance_max = err.mustBePositive ?? "Must be ≥ 0";
  }
  if (
    rate.distance_min !== undefined &&
    rate.distance_max !== undefined &&
    rate.distance_min > rate.distance_max
  ) {
    errors.distance_max = err.maxMustBeGreaterThanMin ?? "Max must be ≥ min";
  }
  if (rate.fixed_amount === undefined || rate.fixed_amount < 0) {
    errors.fixed_amount = err.mustBePositive ?? "Must be ≥ 0";
  }
  if (rate.per_km_amount === undefined || rate.per_km_amount < 0) {
    errors.per_km_amount = err.mustBePositive ?? "Must be ≥ 0";
  }

  return errors;
}